import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';
import useOrganizationName from '../hooks/useOrganizationName';

const FormOrganizationBanner = ({ subtitle }) => {
  const { organizationName, organizationSlug } = useOrganizationName();

  if (!organizationSlug) {
    return null;
  }

  return (
    <Box sx={{ mb: 3, textAlign: 'center' }}>
      <Chip
        icon={<BusinessIcon />}
        label={organizationName}
        color="primary"
        variant="outlined"
        sx={{ fontWeight: 600, px: 1 }}
      />
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default FormOrganizationBanner;
